<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_1662_9811)">
<circle cx="25" cy="25" r="17" transform="rotate(-90 25 25)" fill="#006EFF"/>
<path d="M25 28.7003C24.8208 28.7003 24.6416 28.6319 24.5049 28.4953L20.2051 24.1955C19.9316 23.9219 19.9316 23.4785 20.2051 23.2051C20.4786 22.9316 20.9219 22.9316 21.1955 23.2051L25 27.0098L28.8045 23.2052C29.078 22.9318 29.5213 22.9318 29.7947 23.2052C30.0684 23.4786 30.0684 23.9221 29.7947 24.1956L25.495 28.4954C25.3583 28.632 25.1791 28.7003 25 28.7003Z" fill="white"/>
</g>
<defs>
<filter id="filter0_d_1662_9811" x="0" y="0" width="50" height="50" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="4"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.431373 0 0 0 0 1 0 0 0 0.5 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1662_9811"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1662_9811" result="shape"/>
</filter>
</defs>
</svg>

</template>

<script>

export default {
  props: {
    width: { type: [Number, String], default: 50 },
    height: { type: [Number, String], default: 50 },
    color: { type: String, default: '#006EFF' },
  },
};
</script>
